export default "__VITE_ASSET__DPoO3mAT__"